import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert, sweetAlertWithHtml } from 'src/app/utils/swal';
import { phoneNumberLengthValidator, timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-member-merge-modal',
  templateUrl: './member-merge-modal.component.html',
  styleUrls: ['./member-merge-modal.component.css']
})
export class MemberMergeModalComponent implements OnInit {
  @Input() members: any;
  @Output() closeModal = new EventEmitter<any>();
  search: any;
  primaryMember: any
  memberForm!: FormGroup;
  isSubmitted = false;
  preFundingSource:any = {};

  constructor(
    private memberService: MemberService,
    private fb: FormBuilder,
    private fundingSource: FundingSourceService
  ) { }

  ngOnInit(): void {
    this.memberForm = this.fb.group({
      memberId: ['', Validators.required]
    });
    this.getFundingSource();
  }

  setPrimaryMember(member: any) {
    this.members.forEach((member: any) => member.isPrimary = false);
    member.isPrimary = true;
    this.primaryMember = member;
    this.memberForm.patchValue({
      memberId: member.id
    });
  }

  deleteMember(member: any) {
    if (member.isPrimary) {
      this.memberForm.patchValue({
        memberId: ''
      });
    }
    this.members = this.members.filter((m: any) => m.id !== member.id);
  }

  async save() {
    this.isSubmitted = true;
    if (this.memberForm.invalid) return;

    if (this.members && this.members.length < 2) {
      return;
    }

    const result = await sweetAlert(
      "Alert",
      `Are you sure you want mark the member as primary?`,
      "warning",
      "Yes",
      "No"
    );

    if (result.value) {
      const secondaryMemberIds = this.members
        .filter((member: any) => !member.isPrimary)
        .map((m: any) => m.id);

      const payload = {
        secondary: secondaryMemberIds
      }
      this.memberService
        .markMembersAsPrimary(this.memberForm.value.memberId, payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.closeModal.emit(secondaryMemberIds);
            }
          },
          error: (err: any) => {
            sweetAlert('Error', err, 'error', 'Ok');
          }
        });
    }
  }

  getFundingSource() {
    this.fundingSource.getPicker({ isActive: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preFundingSource = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  get form() {
    return this.memberForm.controls;
  }
}
